const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingDiamont(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 800,
    width: 800,
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "M8.756 5.154 3.178 18.538 25 47.511l21.822-28.973-5.775-13.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M3.146 18.538h43.676M8.756 5.154l6.939 13.384 9.358-13.384 10.381 13.384 5.613-13.384M15.695 18.538 25 47.511l10.434-28.973"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingDiamont);
export default __webpack_public_path__ + "static/media/pricing_diamont.ed3eabd1db33bf105bf9d6819a63439c.svg";
export { ForwardRef as ReactComponent };